/* İlk Kaşık – theme.js
   Kaydırınca belirme, header, çekmeceler, hero slaytı, sayaç, ürün sayfası, arama.
   Kütüphane yok; prefers-reduced-motion'a saygı duyar. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Animasyonlu gizleme yalnızca bu dosya gerçekten çalışırsa açılır; JS hata verirse içerik görünür kalır.
  if (!document.body || !document.body.classList.contains('no-reveal')) document.documentElement.classList.add('ik-anim');
  var isMobile = window.matchMedia('(max-width: 749px)');
  var ik = (window.ik = window.ik || {});

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function store(type) {
    try { return type === 'session' ? window.sessionStorage : window.localStorage; } catch (e) { return null; }
  }

  /* ---------- Kaydırınca belirme ---------- */
  var revealObserver = null;
  function reveal(root) {
    var els = qsa('.js-reveal:not(.is-in), [data-reveal]:not(.is-in)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion.matches || document.body.classList.contains('no-reveal')) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            entry.target.dispatchEvent(new CustomEvent('ik:in'));
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }
  ik.reveal = reveal;

  /* ---------- Sayaç (9,8 gibi) ---------- */
  function countUp(root) {
    qsa('[data-countup]:not([data-counted])', root).forEach(function (el) {
      el.setAttribute('data-counted', '');
      var raw = (el.getAttribute('data-countup') || el.textContent).trim();
      var target = parseFloat(raw.replace(',', '.'));
      if (isNaN(target) || reduceMotion.matches) return;
      var decimals = (raw.split(/[.,]/)[1] || '').length;
      var sep = raw.indexOf(',') > -1 ? ',' : '.';
      var run = function () {
        var start = null;
        var dur = 1200;
        var step = function (t) {
          if (!start) start = t;
          var p = Math.min(1, (t - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals).replace('.', sep);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      el.textContent = (0).toFixed(decimals).replace('.', sep);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); run(); }
        }, { threshold: 0.6 });
        io.observe(el);
      } else { el.textContent = raw; }
    });
  }

  /* ---------- Duyuru çubuğu ---------- */
  function initAnnouncement(root) {
    qsa('[data-announce]', root).forEach(function (bar) {
      var key = 'ik-announce-' + (bar.getAttribute('data-announce') || '');
      var s = store('session');
      if (s && s.getItem(key) === '1' && !(window.Shopify && window.Shopify.designMode)) { bar.hidden = true; return; }
      var btn = qs('[data-announce-close]', bar);
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (s) { try { s.setItem(key, '1'); } catch (e) {} }
        bar.style.height = bar.offsetHeight + 'px';
        bar.classList.add('is-closing');
        setTimeout(function () { bar.hidden = true; }, reduceMotion.matches ? 0 : 320);
      });
    });
  }

  /* ---------- Header: küçülme, aşağıda gizlenme, yukarıda geri gelme ---------- */
  function initHeader() {
    var wrap = qs('[data-header]');
    if (!wrap) return;
    var section = wrap.closest('.shopify-section') || wrap;
    var hideOnScroll = wrap.getAttribute('data-hide-on-scroll') === 'true';
    var lastY = window.scrollY;
    var ticking = false;
    var flowTop = function () {
      // Header'dan önce gelen (akıştaki) öğelerin yüksekliği; sticky olduğundan kendi konumuna bakılamaz
      var t = 0;
      var el = section.previousElementSibling;
      while (el) {
        var pos = window.getComputedStyle(el).position;
        if (pos !== 'absolute' && pos !== 'fixed') t += el.offsetHeight;
        el = el.previousElementSibling;
      }
      return t;
    };
    var update = function () {
      var y = window.scrollY;
      var top = flowTop();
      var compact = y > top + 40;
      wrap.classList.toggle('is-compact', compact);
      if (hideOnScroll && !document.body.classList.contains('is-locked')) {
        var delta = y - lastY;
        if (y > top + 240 && delta > 6) wrap.classList.add('is-hidden');
        else if (delta < -6 || y < top + 240) wrap.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
    wrap.addEventListener('focusin', function () { wrap.classList.remove('is-hidden'); });
  }

  /* ---------- Menü sığmıyorsa hamburgere geç ---------- */
  function initNavFit() {
    var header = qs('.site-header');
    var nav = qs('[data-nav]', header || document);
    if (!header || !nav) return;
    var check = function () {
      header.classList.remove('is-nav-overflow');
      if (window.innerWidth < 990) return;
      if (nav.scrollWidth > nav.clientWidth + 1) header.classList.add('is-nav-overflow');
    };
    check();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(check, 120); });
  }

  /* ---------- Çekmeceler (menü, sepet, arama) ---------- */
  var overlay = null;
  var openDrawer = null;
  var lastFocus = null;
  var focusable = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function getOverlay() {
    if (!overlay) {
      overlay = qs('[data-overlay]');
      if (overlay) overlay.addEventListener('click', function () { closeDrawerFn(); });
    }
    return overlay;
  }

  function openDrawerFn(name, opener) {
    var el = qs('[data-drawer="' + name + '"]');
    if (!el) return;
    if (openDrawer && openDrawer !== el) closeDrawerFn(true);
    lastFocus = opener || document.activeElement;
    el.hidden = false;
    var ov = getOverlay();
    if (ov) { ov.hidden = false; }
    // Bir kare bekle ki geçiş çalışsın
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-open', 'is-entering');
        if (ov) ov.classList.add('is-visible');
        setTimeout(function () { el.classList.remove('is-entering'); }, 1000);
      });
    });
    openDrawer = el;
    document.body.classList.add('is-locked', 'ik-open-' + name);
    qsa('[data-open-' + name + ']').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var target = qs('[data-autofocus]', el) || qsa(focusable, el)[0];
      if (target) target.focus({ preventScroll: true });
    }, reduceMotion.matches ? 0 : 80);
    el.dispatchEvent(new CustomEvent('ik:open'));
  }

  function closeDrawerFn(keepOverlay) {
    var el = openDrawer;
    if (!el) return;
    var name = el.getAttribute('data-drawer');
    el.classList.remove('is-open');
    var ov = getOverlay();
    if (ov && !keepOverlay) {
      ov.classList.remove('is-visible');
      setTimeout(function () { if (!openDrawer) ov.hidden = true; }, 320);
    }
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, reduceMotion.matches ? 0 : 440);
    openDrawer = null;
    document.body.classList.remove('is-locked');
    setTimeout(function () { if (!el.classList.contains('is-open')) document.body.classList.remove('ik-open-' + name); }, reduceMotion.matches ? 0 : 440);
    qsa('[data-open-' + name + ']').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  ik.openDrawer = openDrawerFn;
  ik.closeDrawer = closeDrawerFn;
  ik.isDrawerOpen = function (name) { return !!openDrawer && openDrawer.getAttribute('data-drawer') === name; };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-menu], [data-open-cart], [data-open-search], [data-drawer-close]');
    if (!t) return;
    if (t.hasAttribute('data-drawer-close')) { e.preventDefault(); closeDrawerFn(); return; }
    var name = t.hasAttribute('data-open-menu') ? 'menu' : t.hasAttribute('data-open-cart') ? 'cart' : 'search';
    if (name === 'cart' && t.getAttribute('data-cart-page') === 'true') return; // sepet sayfası tercihi
    e.preventDefault();
    if (openDrawer && openDrawer.getAttribute('data-drawer') === name) { closeDrawerFn(); return; }
    openDrawerFn(name, t);
  });

  document.addEventListener('keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { closeDrawerFn(); return; }
    if (e.key !== 'Tab') return;
    var items = qsa(focusable, openDrawer).filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Hero slaytı ---------- */
  function initHero(root) {
    qsa('[data-hero]', root).forEach(function (hero) {
      if (hero._ikHero) return;
      hero._ikHero = true;
      var slides = qsa('.hero__slide', hero);
      var dots = qsa('.hero__dot', hero);
      if (slides.length < 2) { hero.classList.add('hero--static'); return; }
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && !reduceMotion.matches;
      var speed = parseInt(hero.getAttribute('data-speed') || '6', 10) * 1000;
      hero.style.setProperty('--dur', speed + 'ms');
      if (!autoplay) hero.classList.add('hero--static');
      var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      var timer = null;
      var paused = false;

      function go(i, user) {
        i = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          var on = n === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          qsa('a, button', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        });
        dots.forEach(function (d, n) {
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
          d.classList.toggle('is-done', n < i);
          // Animasyonu baştan başlat
          var bar = d.querySelector('span');
          if (bar && n === i) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        index = i;
        if (user) restart();
      }
      function next() { go(index + 1); }
      function restart() {
        clearTimeout(timer);
        if (autoplay && !paused) timer = setTimeout(function () { next(); restart(); }, speed);
      }
      function pause(state) {
        paused = state;
        hero.classList.toggle('is-paused', state);
        if (state) clearTimeout(timer); else restart();
      }

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { go(n, true); });
        d.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); dots[index].focus(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); dots[index].focus(); }
        });
      });
      hero.addEventListener('mouseenter', function () { if (autoplay) pause(true); });
      hero.addEventListener('mouseleave', function () { if (autoplay) pause(false); });
      hero.addEventListener('focusin', function () { if (autoplay) pause(true); });
      hero.addEventListener('focusout', function (e) { if (autoplay && !hero.contains(e.relatedTarget)) pause(false); });
      document.addEventListener('visibilitychange', function () { if (autoplay) pause(document.hidden); });

      // Kaydırma (dokunmatik)
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1), true);
        x0 = null;
      });

      hero.addEventListener('ik:select', function (e) { go(e.detail.index, true); pause(true); });
      go(index);
      restart();
    });
  }

  /* ---------- Sekmeler / akordeon ---------- */
  function initTabs(root) {
    qsa('[data-tabs]', root).forEach(function (wrap) {
      if (wrap._ikTabs) return;
      wrap._ikTabs = true;
      var tabs = qsa('[role="tab"]', wrap);
      var panels = qsa('.tabs__panel', wrap);
      function select(id, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === id;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-tab')); });
        t.addEventListener('keydown', function (e) {
          var k = e.key;
          var n = null;
          if (k === 'ArrowRight') n = (i + 1) % tabs.length;
          if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (k === 'Home') n = 0;
          if (k === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(tabs[n].getAttribute('data-tab'), true); }
        });
      });
      qsa('[data-acc]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var panel = b.closest('.tabs__panel');
          var open = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', open);
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Adet seçici (sepet satırı olmayanlar) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var wrap = b.closest('[data-qty]');
    if (!wrap || wrap.hasAttribute('data-line')) return; // sepet satırını cart.js yönetir
    var input = qs('input', wrap);
    var min = parseInt(input.min || '1', 10);
    var v = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v;
    wrap.classList.remove('is-tick'); void wrap.offsetWidth; wrap.classList.add('is-tick');
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Ürün sayfası ---------- */
  function initProduct(root) {
    qsa('[data-product]', root).forEach(function (pdp) {
      if (pdp._ikProduct) return;
      pdp._ikProduct = true;
      var sectionId = pdp.getAttribute('data-section');
      var form = qs('form[data-product-form]', pdp);
      var idInput = form ? qs('input[name="id"]', form) : null;

      // Galeri
      var track = qs('[data-gallery-track]', pdp);
      var slides = track ? qsa('.gallery__slide', track) : [];
      var thumbs = qsa('[data-thumb]', pdp);
      var dots = qsa('[data-dot]', pdp);
      var counter = qs('[data-gallery-count]', pdp);
      var current = 0;
      function mark(i) {
        current = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        dots.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      }
      function goSlide(i, smooth) {
        if (!track || !slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reduceMotion.matches ? 'auto' : 'smooth' });
        mark(i);
      }
      if (track && slides.length > 1) {
        var scrollT = null;
        track.addEventListener('scroll', function () {
          clearTimeout(scrollT);
          scrollT = setTimeout(function () {
            var i = Math.round(track.scrollLeft / track.clientWidth);
            if (i !== current) mark(i);
            slides.forEach(function (s) { s.classList.remove('is-zoomed'); });
          }, 60);
        }, { passive: true });
        thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goSlide(n); }); });
        dots.forEach(function (t, n) { t.addEventListener('click', function () { goSlide(n); }); });
      }
      // Masaüstünde tıklayınca yakınlaştır
      slides.forEach(function (s) {
        if (!qs('img', s)) return;
        s.classList.add('is-zoomable');
        s.addEventListener('click', function (e) {
          if (isMobile.matches) return;
          s.classList.toggle('is-zoomed');
          move(e);
        });
        var move = function (e) {
          var r = s.getBoundingClientRect();
          s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        };
        s.addEventListener('mousemove', function (e) { if (s.classList.contains('is-zoomed')) move(e); });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoomed'); });
      });

      // Varyant seçimi
      var variantsEl = qs('[data-variants]', pdp);
      var variants = [];
      try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }
      var picker = qs('[data-variant-picker]', pdp);
      function selectedOptions() {
        return qsa('[data-option-group]', picker).map(function (g) {
          var c = qs('input:checked', g);
          return c ? c.value : null;
        });
      }
      function setButtons(variant) {
        qsa('[data-atc]', document).forEach(function (btn) {
          var label = qs('.atc__label-text', btn);
          if (!variant) {
            btn.disabled = true;
            if (label) label.textContent = window.ikTheme.strings.unavailable;
          } else if (!variant.available) {
            btn.disabled = true;
            if (label) label.textContent = window.ikTheme.strings.soldOut;
          } else {
            btn.disabled = false;
            if (label) label.textContent = window.ikTheme.strings.addToCart;
          }
        });
      }
      if (picker && variants.length) {
        picker.addEventListener('change', function () {
          var opts = selectedOptions();
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
          setButtons(v);
          if (!v) return;
          if (idInput) idInput.value = v.id;
          var url = pdp.getAttribute('data-url') + '?variant=' + v.id;
          window.history.replaceState({}, '', url);
          if (v.featured_media) {
            var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.featured_media.id); });
            if (idx > -1) goSlide(idx);
          }
          fetch(url + '&section_id=' + sectionId)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              qsa('[data-swap]', pdp).forEach(function (el) {
                var key = el.getAttribute('data-swap');
                var fresh = doc.querySelector('[data-swap="' + key + '"]');
                if (fresh) el.innerHTML = fresh.innerHTML;
              });
              qsa('[data-swap-sticky]', document).forEach(function (el) {
                var key = el.getAttribute('data-swap-sticky');
                var fresh = doc.querySelector('[data-swap-sticky="' + key + '"]');
                if (fresh) { el.innerHTML = fresh.innerHTML; el.className = fresh.className; }
              });
            })
            .catch(function () {});
        });
      }

      // Mobil sabit "Sepete ekle" çubuğu
      var sticky = qs('[data-sticky-atc]');
      var mainBtn = form ? qs('[data-atc]', form) : null;
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        io.observe(mainBtn);
      }
      // Sabit çubuktaki adet, formdakiyle aynı
      if (sticky && form) {
        var qtyInput = qs('input[name="quantity"]', form);
        var meta = qs('[data-sticky-qty]', sticky);
        if (qtyInput && meta) {
          form.addEventListener('change', function () { meta.textContent = qtyInput.value; });
        }
      }
    });
  }

  /* ---------- Birlikte iyi gider (öneri API'si) ---------- */
  function initRecs(root) {
    qsa('[data-recs-url]', root).forEach(function (el) {
      if (el._ikRecs) return;
      el._ikRecs = true;
      fetch(el.getAttribute('data-recs-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recs-body]');
          if (fresh && fresh.children.length) {
            el.innerHTML = fresh.innerHTML;
            el.closest('[data-recs-wrap]').hidden = false;
            reveal(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Koleksiyon sıralama ---------- */
  function initSort(root) {
    qsa('[data-sort]', root).forEach(function (sel) {
      if (sel._ikSort) return;
      sel._ikSort = true;
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        var wrap = sel.closest('[data-collection]');
        if (wrap) wrap.classList.add('is-loading');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Footer: masaüstünde menüler hep açık ---------- */
  function initFooter(root) {
    var menus = qsa('[data-footer-menu]', root);
    if (!menus.length) return;
    var apply = function () {
      menus.forEach(function (d) {
        if (isMobile.matches) { if (!d._ikTouched) d.open = false; }
        else d.open = true;
      });
    };
    menus.forEach(function (d) {
      var s = qs('summary', d);
      s.addEventListener('click', function (e) {
        if (!isMobile.matches) e.preventDefault();
        else d._ikTouched = true;
      });
    });
    apply();
    if (isMobile.addEventListener) isMobile.addEventListener('change', apply);
  }

  /* ---------- Tahminli arama ---------- */
  function initSearch() {
    var panel = qs('[data-drawer="search"]');
    if (!panel) return;
    var input = qs('input[type="search"]', panel);
    var results = qs('[data-search-results]', panel);
    if (!input || !results) return;
    var t = null;
    var ctrl = null;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = window.ikTheme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var body = doc.querySelector('[data-predictive]');
            results.innerHTML = body ? body.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  }


  /* ---------- Yorumlar: fotoğraf şeridi + pencere ---------- */
  function initReviews(root) {
    qsa('[data-reviews]', root).forEach(function (wrap) {
      if (wrap._ikReviews) return;
      wrap._ikReviews = true;
      var data = [];
      try { data = JSON.parse(qs('[data-reviews-json]', wrap).textContent); } catch (e) { data = []; }
      var modal = qs('[data-review-modal]', wrap);
      var track = qs('[data-rphotos-track]', wrap);

      // Rastgele sıra: Shopify sayfayı önbelleğe aldığı için karıştırma her açılışta tarayıcıda yapılır
      var shuffle = function (arr) {
        for (var i = arr.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
        }
        return arr;
      };
      var keyOf = function (li) {
        var b = qs('[data-review-open]', li);
        return b ? b.getAttribute('data-review-open') : '';
      };
      if (track) {
        shuffle(qsa('.rphoto', track)).forEach(function (li, n) {
          li.style.setProperty('--d', (n % 6) * 60 + 'ms');
          track.appendChild(li);
        });
      }
      var groups = qsa('.reviews__group, .rgrid', wrap);
      if (groups.length) {
        var keys = shuffle(qsa('.rcard', groups[0])).map(function (li) {
          groups[0].appendChild(li);
          return keyOf(li);
        });
        // Kayan şeridin ikinci (kopya) grubu aynı sırayı izler, yoksa döngü kopukluğu görünür
        groups.slice(1).forEach(function (g) {
          var map = {};
          qsa('.rcard', g).forEach(function (li) { map[keyOf(li)] = li; });
          keys.forEach(function (k) { if (map[k]) g.appendChild(map[k]); });
        });
      }
      // Penceredeki önceki/sonraki, sayfadaki karışık sırayı izler: önce fotoğraflılar, sonra diğerleri
      var order = qsa('.rphoto', wrap).map(keyOf);
      if (groups.length) order = order.concat(qsa('.rcard', groups[0]).map(keyOf));
      order = order.filter(function (k) { return k !== ''; }).map(function (k) { return parseInt(k, 10); });

      // Fotoğraf şeridi okları
      if (track) {
        var step = function (dir) {
          var item = qs('.rphoto', track);
          var w = item ? item.getBoundingClientRect().width + 12 : 200;
          track.scrollBy({ left: dir * w * 3, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        };
        var prev = qs('[data-rphotos-prev]', wrap);
        var next = qs('[data-rphotos-next]', wrap);
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
        var syncArrows = function () {
          if (!prev || !next) return;
          prev.disabled = track.scrollLeft < 4;
          next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
        };
        track.addEventListener('scroll', syncArrows, { passive: true });
        syncArrows();
      }

      if (!modal || !data.length) return;
      if (typeof modal.showModal !== 'function') modal.classList.add('is-polyfill');
      if (!order.length) order = data.map(function (_, n) { return n; });
      var pos = 0;
      var photo = 0;
      var photos = [];
      var lastFocus = null;
      var el = function (n) { return qs('[data-rm-' + n + ']', modal); };
      var star = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 3.2l2.6 5.3 5.8.85-4.2 4.1 1 5.8L12 16.5l-5.2 2.75 1-5.8-4.2-4.1 5.8-.85z" fill="currentColor"/></svg>';

      function showPhoto(i) {
        if (!photos.length) return;
        photo = (i + photos.length) % photos.length;
        qsa('.rmodal__slide', modal).forEach(function (s, n) { s.classList.toggle('is-active', n === photo); });
        qsa('.rmodal__dot', modal).forEach(function (d, n) { d.setAttribute('aria-current', n === photo ? 'true' : 'false'); });
      }
      function render(p) {
        pos = (p + order.length) % order.length;
        var r = data[order[pos]] || {};
        photos = (r.ph && r.ph.length) ? r.ph : (r.pi ? [r.pi] : []);
        var isProductImg = !(r.ph && r.ph.length);
        el('media').hidden = !photos.length;
        modal.classList.toggle('rmodal--noimg', !photos.length);
        el('slides').innerHTML = '';
        el('dots').innerHTML = '';
        photos.forEach(function (src, n) {
          var d = document.createElement('div');
          d.className = 'rmodal__slide' + (isProductImg ? ' rmodal__slide--product' : '');
          var img = document.createElement('img');
          img.src = src; img.alt = isProductImg ? '' : (window.ikTheme.strings.reviewPhoto || '') + ' ' + (n + 1);
          img.decoding = 'async';
          d.appendChild(img);
          el('slides').appendChild(d);
          if (photos.length > 1) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'rmodal__dot';
            b.setAttribute('aria-label', (n + 1) + ' / ' + photos.length);
            b.addEventListener('click', function () { showPhoto(n); });
            el('dots').appendChild(b);
          }
        });
        el('prev').hidden = el('next').hidden = photos.length < 2;
        showPhoto(0);
        el('stars').innerHTML = new Array((r.s || 5) + 1).join(star);
        el('stars').setAttribute('aria-label', (r.s || 5) + ' / 5');
        el('text').textContent = r.t || '';
        el('name').textContent = r.n || '';
        el('date').textContent = r.d ? '· ' + r.d : '';
        var link = el('product');
        if (r.u || r.p) {
          link.hidden = false;
          link.href = r.u || '#';
          if (!r.u) link.removeAttribute('href');
          el('pname').textContent = r.p || '';
          el('pimg').innerHTML = r.pi ? '<img src="' + r.pi + '" alt="" width="48" height="48">' : '';
        } else { link.hidden = true; }
        var body = qs('.rmodal__body', modal);
        if (body) body.scrollTop = 0;
        modal.classList.remove('is-swap'); void modal.offsetWidth; modal.classList.add('is-swap');
      }
      function open(i) {
        lastFocus = document.activeElement;
        var p = order.indexOf(i);
        render(p < 0 ? 0 : p);
        if (modal.showModal && !modal.open) modal.showModal(); else modal.setAttribute('open', '');
        document.body.classList.add('is-locked');
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      }
      function close() {
        modal.classList.remove('is-open');
        var done = function () {
          if (modal.close && modal.open) modal.close(); else modal.removeAttribute('open');
          document.body.classList.remove('is-locked');
          if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
        };
        setTimeout(done, reduceMotion.matches ? 0 : 220);
      }

      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-review-open]');
        if (b) { e.preventDefault(); open(parseInt(b.getAttribute('data-review-open'), 10)); }
      });
      qs('[data-review-close]', modal).addEventListener('click', close);
      modal.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      el('prev').addEventListener('click', function () { showPhoto(photo - 1); });
      el('next').addEventListener('click', function () { showPhoto(photo + 1); });
      qs('[data-rm-prev-review]', modal).addEventListener('click', function () { render(pos - 1); });
      qs('[data-rm-next-review]', modal).addEventListener('click', function () { render(pos + 1); });
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); if (photos.length > 1) showPhoto(photo + 1); else render(pos + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); if (photos.length > 1) showPhoto(photo - 1); else render(pos - 1); }
      });
      var x0 = null;
      el('media').addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el('media').addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) showPhoto(photo + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* ---------- Başlat ---------- */
  function safe(fn, arg) {
    try { fn(arg); } catch (e) { if (window.console) console.error('[ik]', e); }
  }
  function init(root) {
    [reveal, countUp, initAnnouncement, initHero, initTabs, initProduct, initRecs, initSort, initFooter, initReviews]
      .forEach(function (fn) { safe(fn, root); });
  }

  function boot() {
    init(document);
    safe(initNavFit);
    safe(initHeader);
    safe(initSearch);
    // Son güvence: 3 sn sonra ekranda hâlâ görünmeyen öğe kalırsa göster
    setTimeout(function () {
      qsa('.js-reveal:not(.is-in), [data-reveal]:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Tema düzenleyicisi */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest('[data-hero]');
    if (hero) {
      var slides = qsa('.hero__slide', hero);
      var i = slides.indexOf(e.target.closest('.hero__slide'));
      if (i > -1) hero.dispatchEvent(new CustomEvent('ik:select', { detail: { index: i } }));
    }
    qsa('.js-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-drawer="cart"]')) openDrawerFn('cart');
  });
})();
